import { createContext } from "react";

export const CheckboxCheckedContext = createContext(false);
